<template>
  <div>
    <div
      v-if="newsletter"
      class="newsletter-register-confirmation"
    >
      <fn-section
        constrained="l"
        background-color="sand-light"
        padding-top="xs"
        padding-bottom="xs"
      >
        <fn-breadcrumbs :nodes="page.content.breadcrumbs" />
      </fn-section>

      <fn-newsletter-confirmation-section
        :newsletter="newsletter"
        :image="image"
      />

      <fn-cms-section-loader
        v-if="page.content.content_slots.a && page.content.content_slots.a.sections"
        :sections="page.content.content_slots.a.sections"
      />

      <fn-cms-section-loader
        v-if="page.content.content_slots.b && page.content.content_slots.b.sections"
        :sections="page.content.content_slots.b.sections"
      />

      <fn-adobe-target-mbox id="newsletter_unreg_promotSlot_1" />
      <fn-adobe-target-mbox id="newsletter_unreg_promotSlot_2" />
      <fn-adobe-target-mbox id="newsletter_unreg_promotSlot_3" />
    </div>
    <div v-else>
      <fn-error :image="errorImage" />
    </div>
  </div>
</template>

<script>
import ErrorImage from '@/assets/img/error-img.jpg';

export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
    newsletter: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      default: null,
    },
  },
  computed: {
    errorImage() {
      return ErrorImage;
    },
  },
});
</script>
